package com.tixforgigs.common.core.util

import com.tixforgigs.apax.models.AuthToken
import com.tixforgigs.common.core.extensions.orElse
import com.tixforgigs.common.core.extensions.tryCatchSentry
import com.tixforgigs.common.core.models.embed.*
import com.tixforgigs.common.core.util.StorageUtil.deleteStorageItem
import com.tixforgigs.common.core.util.StorageUtil.setStorageItem
import js.array.ReadonlyArray
import kotlinx.browser.window
import kotlinx.serialization.json.Json
import org.w3c.dom.MessageEvent
import web.dom.document
import web.resize.ResizeObserver
import web.resize.ResizeObserverEntry

actual object EmbedUtil {
  @OptIn(ExperimentalWasmJsInterop::class)
  actual fun init() {
    val body = document.body

    window.onload = {
      postToParentPage(PostMessageHandshakeDTO())
    }

    val resize = ResizeObserver { entries, _ ->
      sendIframeHeight(entries = entries)
    }
    resize.observe(body)

    window.addEventListener("message", { event ->
      runCatching { event.unsafeCast<MessageEvent>() }.getOrNull()?.let { messageEvent ->
        val messageData = messageEvent.data.toString()

        runCatching {
          Json.decodeFromString<PostMessageEmbedOriginDTO>(messageData)
        }.getOrNull()?.let { originMessage ->
          document.documentElement.dataset["embed"] = true.toString()
          document.documentElement.dataset["origin"] = originMessage.origin
        }

        runCatching {
          Json.decodeFromString<PostMessageEmbedAuthDTO>(messageData)
        }.getOrNull()?.let { authMessage ->
          authMessage.authToken?.let { authToken ->
            setStorageItem<AuthToken>(
              key = StorageUtil.StorageKey.AuthToken,
              item = authToken,
              serializer = AuthToken.serializer()
            )
          }
          authMessage.internalRedirectPath?.let { path ->
            deleteStorageItem(StorageUtil.StorageKey.LoginStartLocation)
            window.location.pathname = path
          }
        }

        runCatching {
          Json.decodeFromString<PostMessageEmbedNavigateDTO>(messageData)
        }.getOrNull()?.let { navigateMessage ->
          window.location.pathname = navigateMessage.embedPathToNavigate
        }
      }
    })
  }

  @OptIn(ExperimentalWasmJsInterop::class)
  actual inline fun <reified T> postToParentPage(value: T) {
    window.parent.postMessage(
      message = Json.encodeToString(value),
      targetOrigin = document.documentElement.dataset["origin"].orElse { "*" }
    )
  }

  private fun sendIframeHeight(entries: ReadonlyArray<ResizeObserverEntry>) {
    entries.let { entries ->
      entries.forEach { entry ->
        tryCatchSentry { entry.contentRect.height.toInt() }
          .onSuccess { height ->
            postToParentPage(
              value = PostMessageEmbedHeightDTO(
                height = height
              )
            )
          }
      }
    }
  }
}
